import type { Connection } from "@/lib/types";

// Mirrors the backend role catalogue, including its normalized legacy aliases.
export const isOrdinarySingleton = (connection: Connection) => {
  const role = connection.connectionType.replace("_to_legacy_", "_to_");
  return (
    role.endsWith("_to_primary_contact") ||
    [
      "vehicle_to_driver",
      "insurance_claim_to_insurer",
      "insurance_claim_to_insurance_provider",
      "insurance_claim_to_adjuster",
      "insurance_claim_to_medpay_adjuster",
      "insurance_claim_to_property_damage_adjuster",
    ].includes(role)
  );
};

export const singletonPeerRevisions = (
  current: Connection,
  connections: Connection[],
) =>
  Object.fromEntries(
    isOrdinarySingleton(current)
      ? connections
          .filter(
            (peer) =>
              peer.id !== current.id &&
              peer.state === "active" &&
              peer.sourceObjectType === current.sourceObjectType &&
              peer.sourceObjectId === current.sourceObjectId &&
              peer.targetObjectId === current.targetObjectId &&
              peer.connectionType.replace("_to_legacy_", "_to_") ===
                current.connectionType.replace("_to_legacy_", "_to_"),
          )
          .map((peer) => [peer.id, peer.editRevision])
      : [],
  );
